import * as Datefns from 'date-fns';

export const getFormatDate = (date, fm = 'yyyy.MM.dd') =>
	Datefns.format(date, fm);

export const addMonths = (date, amount) => Datefns.addMonths(date, amount);

export const subMonths = (date, amount) => Datefns.subMonths(date, amount);

export const addDays = (date, amount) => Datefns.addDays(date, amount);

export const subDays = (date, amount) => Datefns.subDays(date, amount);

export const monthStart = (date) => Datefns.startOfMonth(date);

export const monthEnd = (date) => Datefns.endOfMonth(date);

export const startDate = (date) => Datefns.startOfWeek(date);

export const endDate = (date) => Datefns.endOfWeek(date);

export const getWeekDay = (date) => Datefns.getDay(date);

// export const differenceInBusinessDays = (date1, date2) => Datefns.differenceInBusinessDays(date1, date2);
